import { useTranslate } from 'ra-core'

const ExpoHomepageTitle = ({ record }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Expo Homepage Highlight')} - {record && record.title ? `"${record.title}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./ExpoHomepages'), component: 'ExpoHomepageList' },
  create: { lazy: () => import('./ExpoHomepages'), component: 'ExpoHomepageCreate' },
  edit: { lazy: () => import('./ExpoHomepages'), component: 'ExpoHomepageEdit' },
  options: {
    create: {
      title: 'Expo Homepage Highlights',
      subtitle: null,
      breadCrumb: 'Create Expo Homepage Highlight',
    },
    list: {
      title: 'Expo Homepage Highlights',
      subtitle: null,
      breadCrumb: 'Expo Homepage Highlights',
    },
    edit: {
      title: <ExpoHomepageTitle />,
      subtitle: null,
      breadCrumb: 'Edit Expo Homepage Highlight',
    },
  },
}
